module.exports = {
  USER_TAG_PREFIX: '@',
  MEDICAL_RECORD_TAG_PREFIX: '#',

  REGEX_MEDICAL_RECORD_TAG: /(#{{\d+_[a-z'.,\- \d]{1,32}_[a-z'.,\- \d]{1,32}}})/i,
  REGEX_USER_TAG: /(@{{\d+_[a-z'.,\- \d]{1,32}_[a-z'.,\- \d]{1,32}}})/i,
  REGEX_TAG_PARSE: /[{_}]+/,

  UNKNOWN_TAG_TIPS: 'Not in Channel',
};



// WEBPACK FOOTER //
// ./src/modules/messaging/costants.js